import { ShowColumnsFilter } from "@/components/ColumnMenu";
import {
  ActionCellPopupSettings,
  ToggleLevelActiveCell,
} from "@/components/custom-cells";
import { IProject } from "@/interfaces/project.interface";
import { MIN_RESIZABLE_WIDTH_KENDO_TABLE } from "@/utils/kendo";

export interface columnInterface {
  title?: string;
  field?: string;
  show?: boolean;
  filter?: "boolean" | "numeric" | "text" | "date" | undefined;
  minWidth?: number;
  minGridWidth?: number;
  locked?: boolean;
  width?: string | number;
  columnMenu?: any;
  minResizableWidth?: number;
  cells?: any;
}

export const generateColumns = (
  handleEditClick: any,
  onColumnsSubmit: any,
  columnsExternal?: any,
  enableDisableLevel?: (dataItem: IProject) => void
): any => {
  const columns = [
    {
      title: "Name",
      field: "name",
      show: true,
      columnMenu: (props: any) => (
        <ShowColumnsFilter
          {...props}
          columns={columns || columnsExternal}
          onColumnsSubmit={onColumnsSubmit}
          showColumnMenu={true}
        />
      ),
      cells: {
        data: (props: any) => (
          <ActionCellPopupSettings
            rowData={props.dataItem}
            handleEditClick={handleEditClick}
            dataKey="name"
          />
        ),
      },
      minResizableWidth: MIN_RESIZABLE_WIDTH_KENDO_TABLE,
    },
    {
      title: "Code",
      field: "code",
      show: true,
      columnMenu: (props: any) => (
        <ShowColumnsFilter
          {...props}
          columns={columns || columnsExternal}
          onColumnsSubmit={onColumnsSubmit}
          showColumnMenu={true}
        />
      ),
      minResizableWidth: MIN_RESIZABLE_WIDTH_KENDO_TABLE,
    },
    {
      title: "Active",
      field: "isActive",
      show: true,
      columnMenu: (props: any) => (
        <ShowColumnsFilter
          {...props}
          columns={columns || columnsExternal}
          onColumnsSubmit={onColumnsSubmit}
          showColumnMenu={true}
        />
      ),
      cells: {
        data: (props: any) => (
          <ToggleLevelActiveCell
            {...props}
            enableDisable={enableDisableLevel}
          />
        ),
      },
      minResizableWidth: MIN_RESIZABLE_WIDTH_KENDO_TABLE,
    },
  ];

  return columns;
};
